import { useQuery } from "react-query";
import { get } from "../../data";

export const useDigitalLite = () => {
    return useQuery({
        queryKey: ["digitalLightChangeReason"],
        queryFn: () => get("/picklists/DigitalToDigitalLiteChangeReason"),
    });
};
